module.exports = __webpack_public_path__ + "static/logo-white-36e372594a5c7453c74fb8f81912d7d8.png";